var WaitBoardItemModel = Backbone.Epoxy.Model.extend({
  initialize: function() { },

  defaults: {
    expectedWaitTimeMins: null,
    isMainGuest: false,
    isSecondaryGuest: false,
    guestName: null,
    employeeName: null,
    hasEmployee: false,
    positionInLine: 0,
  },

  computeds: { },

  validation: { },

  bindModel: function(waitListInfo, index) {
    this.bindingData = true;

    this.set('expectedWaitTimeMins', (waitListInfo.expectedWaitTimeMins || 0) + " mins.");

    this.set('isMainGuest', waitListInfo.isMainGuest || false);
    this.set('isSecondaryGuest', waitListInfo.isSecondaryGuest || false);
    this.set('guestName', waitListInfo.clientName);
    this.set('employeeName', waitListInfo.employeeName);
    this.set('hasEmployee', !_.isEmpty(waitListInfo.employeeName));
    this.set('positionInLine', (index + 1).toString().padStart(2, "0"));

    this.bindingData = false;
  },

  isMyGuestOrMyself: function() {
    return this.get('isMainGuest') || this.get('isSecondaryGuest')
  },

});

module.exports = WaitBoardItemModel;
